
import { createApp } from 'vue';
import { createHead } from '@vueuse/head';
import App from './App.vue';
import router from './router';
import { createI18n } from 'vue-i18n';

import nl from './locales/nl.json';
import fr from './locales/fr.json';
import en from './locales/en.json';
import de from './locales/de.json';

const supportedLocales = ['nl', 'fr', 'en', 'de'];
const defaultLocale = 'nl';

const getStoredLocale = () => {
  try {
    const storedLocale = window.localStorage.getItem('korpus-language')?.toLowerCase();
    return supportedLocales.includes(storedLocale) ? storedLocale : defaultLocale;
  } catch (error) {
    return defaultLocale;
  }
};

const initialLocale = getStoredLocale();

document.documentElement.lang = initialLocale;

const i18n = createI18n({
    locale: initialLocale,
    fallbackLocale: defaultLocale,
    messages: {
      nl,
      fr,
      en,
      de
    }
  });
  
const app = createApp(App);
const head = createHead();

// Vue 3 migration: use app-level plugins instead of Vue.use.
app.use(router);
app.use(head);
app.use(i18n);

app.mount('#app');
